import { useFormikContext } from 'formik'
import React, { useEffect } from 'react'
import { editActivity, EditActivityFields, isClimateInput, isMoistureInput } from './utils'
import { getCapitalizationYears } from "@utils/helperFunctions"
import { ActivityUpdatePayload } from '@features/activities/activityTypes'
import { useClimateAndMoistureFormHandlers } from '@app/hooks'
import GenericInputGroup from '@components/input/inputGroup/GenericInputGroup'
import ActivityDefaultSocSubmodule from './ActivityDefaultSocSubmodule'

interface EditActivityContentProps {
  isLoading: boolean
}
const EditActivityContent: React.FC<EditActivityContentProps> = ({ isLoading }) => {
  const { values, setFieldValue } = useFormikContext<ActivityUpdatePayload>()
  const { handleClimateInputChange, getMoistureOptions } = useClimateAndMoistureFormHandlers();

  useEffect(() => {
    const captalizationPhase = getCapitalizationYears(values.activity.start_year_t2, values.activity.duration_t2, values.activity.last_year_of_accounting_t2)
    setFieldValue(EditActivityFields.capitalization_years, captalizationPhase)
  }, [values.activity.start_year_t2, values.activity.duration_t2, values.activity.last_year_of_accounting_t2, setFieldValue]);

  return (
    <div>
      {editActivity.inputGroups.map((input, index) => {
        if (isMoistureInput(input)) {
          input.dropdownOptions = getMoistureOptions(values.activity.climate_t2)
        }
        if (isClimateInput(input)) {
          input.onChange = (e: any) => {
            handleClimateInputChange(e, values.activity.moisture_t2, EditActivityFields.moisture_t2)
          }
        }
        return (
          <div key={`${input.label}-${index}`}>
            <div className="py-1">
              <GenericInputGroup
                inputGroup={{ ...input, disabled: isLoading || input.disabled }}
              />
            </div>
            {isMoistureInput(input) ? (
              <ActivityDefaultSocSubmodule
                climateField={EditActivityFields.climate_t2}
                moistureField={EditActivityFields.moisture_t2}
                socT2Field={EditActivityFields.soc_t2}
                disabled={isLoading}
              />
            ) : null}
          </div>
        )
      })}
    </div>
  )
}

export default EditActivityContent